"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("@cian/analytics");
var authentication_widget_1 = require("@cian/authentication-widget");
var EVENT_TWO_FACTOR_MAPPER = (_a = {},
    _a[authentication_widget_1.ETwoFactorType.Sms] = 'phone_',
    _a[authentication_widget_1.ETwoFactorType.Email] = 'email_',
    _a);
var PAGE = {
    pageType: 'AddForm',
    siteType: 'desktop',
    extra: {
        type: 'New_ad',
    },
};
/**
 * скрытие попапа авторизации
 */
function trackCloseAuthPopup() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'close',
        label: '',
        page: PAGE,
    });
}
exports.trackCloseAuthPopup = trackCloseAuthPopup;
/**
 * Успешная авторизация
 */
function trackAuthenticateSuccess(socialType) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'success',
        label: socialType || '',
        page: PAGE,
    });
}
exports.trackAuthenticateSuccess = trackAuthenticateSuccess;
/**
 * Клик на кнопку "забыли пароль" при авторизации
 */
function trackForgotPasswordClick() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'forgot_password_click',
        label: '',
        page: PAGE,
    });
}
exports.trackForgotPasswordClick = trackForgotPasswordClick;
/**
 * Клик на кнопку "забыли пароль" при мердже
 */
function trackForgotPasswordClickMerge() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_forgot_password',
        label: '',
        page: PAGE,
    });
}
exports.trackForgotPasswordClickMerge = trackForgotPasswordClickMerge;
/**
 * Успешная отправка формы "забыли пароль"
 */
function trackForgotPasswordSubmitSuccess() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'get_password',
        label: '',
        page: PAGE,
    });
}
exports.trackForgotPasswordSubmitSuccess = trackForgotPasswordSubmitSuccess;
/**
 * Успешная регистрация
 */
function trackRegistrationSuccess(socialType) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Registration',
        action: 'success',
        label: socialType || '',
        page: PAGE,
    });
}
exports.trackRegistrationSuccess = trackRegistrationSuccess;
/**
 * Подписка на новости
 */
function trackWantsSubscription() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Subscription',
        action: 'send',
        label: 'news',
        page: PAGE,
    });
}
exports.trackWantsSubscription = trackWantsSubscription;
/**
 * Показ попапа "Отправлено письмо"
 */
function trackRegistrationDonePopup() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_email_popup_show',
        page: PAGE,
    });
}
exports.trackRegistrationDonePopup = trackRegistrationDonePopup;
/**
 * Закрытие попапа "Отправлено письмо"
 */
function trackRegistrationDonePopupClose() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_email_popup_got_it',
        page: PAGE,
    });
}
exports.trackRegistrationDonePopupClose = trackRegistrationDonePopupClose;
/**
 * Открытие попапа двухфакторной авторизации
 */
function trackTwoFactorPopupOpen(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Open',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "reg_popup",
        page: PAGE,
    });
}
exports.trackTwoFactorPopupOpen = trackTwoFactorPopupOpen;
/**
 * Закрытие попапа двухфакторной авторизации
 */
function trackTwoFactorClose(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "close",
        page: PAGE,
    });
}
exports.trackTwoFactorClose = trackTwoFactorClose;
/**
 * Открытие попапа после нескольких попыток ввода неправильного кода
 */
function trackTwoFactorAttemptsExhaustedPopupOpen(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Fail',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "fatal",
        page: PAGE,
    });
}
exports.trackTwoFactorAttemptsExhaustedPopupOpen = trackTwoFactorAttemptsExhaustedPopupOpen;
function trackTwoFactorInvalid(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Fail',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "simple",
        page: PAGE,
    });
}
exports.trackTwoFactorInvalid = trackTwoFactorInvalid;
function trackTwoFactorWhatForClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "what_for",
        page: PAGE,
    });
}
exports.trackTwoFactorWhatForClick = trackTwoFactorWhatForClick;
function trackTwoFactorContinueClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "continue",
        page: PAGE,
    });
}
exports.trackTwoFactorContinueClick = trackTwoFactorContinueClick;
function trackTwoFactorResendClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "send_again",
        page: PAGE,
    });
}
exports.trackTwoFactorResendClick = trackTwoFactorResendClick;
function trackTwoFactorCannotConfirmClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "cant_confirm",
        page: PAGE,
    });
}
exports.trackTwoFactorCannotConfirmClick = trackTwoFactorCannotConfirmClick;
function trackTwoFactorAttemptsExhaustedSupportClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "write_to_support",
        page: PAGE,
    });
}
exports.trackTwoFactorAttemptsExhaustedSupportClick = trackTwoFactorAttemptsExhaustedSupportClick;
function trackSocialButtonClick(type) {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'click',
        label: type,
        page: PAGE,
    });
}
exports.trackSocialButtonClick = trackSocialButtonClick;
function trackSocialAuthenticateEmailTaken() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_show',
        page: PAGE,
    });
}
exports.trackSocialAuthenticateEmailTaken = trackSocialAuthenticateEmailTaken;
function trackSocialMergeMergeClick() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_click',
        page: PAGE,
    });
}
exports.trackSocialMergeMergeClick = trackSocialMergeMergeClick;
function trackSocialMergeSucceed() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'link_accounts_success',
        page: PAGE,
    });
}
exports.trackSocialMergeSucceed = trackSocialMergeSucceed;
function trackConfirmPhoneShown() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_show',
        page: PAGE,
    });
}
exports.trackConfirmPhoneShown = trackConfirmPhoneShown;
function trackConfirmPhoneConfirmClick() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_click',
        page: PAGE,
    });
}
exports.trackConfirmPhoneConfirmClick = trackConfirmPhoneConfirmClick;
function trackConfirmPhoneResendClick() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_retry',
        page: PAGE,
    });
}
exports.trackConfirmPhoneResendClick = trackConfirmPhoneResendClick;
function trackConfirmPhoneSucceed() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_success',
        page: PAGE,
    });
}
exports.trackConfirmPhoneSucceed = trackConfirmPhoneSucceed;
function trackSocialCreateShow() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'complete_reg_popup_show',
        page: PAGE,
    });
}
exports.trackSocialCreateShow = trackSocialCreateShow;
function trackSocialCreateCreateClick() {
    analytics_1.ca('eventSite', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'complete_reg_popup_click',
        page: PAGE,
    });
}
exports.trackSocialCreateCreateClick = trackSocialCreateCreateClick;
var EFlowChangeType;
(function (EFlowChangeType) {
    EFlowChangeType["Id"] = "id";
    EFlowChangeType["Email"] = "email";
})(EFlowChangeType = exports.EFlowChangeType || (exports.EFlowChangeType = {}));
function trackFlowChange(flow, type) {
    switch (flow) {
        case "authentication" /* Authentication */:
            analytics_1.ca('eventSite', {
                name: 'oldevent',
                category: 'AuthBlock',
                action: 'get_password_input',
                label: type,
                page: PAGE,
            });
            break;
        case "registration" /* Registration */:
            analytics_1.ca('eventSite', {
                name: 'oldevent',
                category: 'AuthBlock',
                action: 'make_new_password_input',
                page: PAGE,
            });
            break;
    }
}
exports.trackFlowChange = trackFlowChange;



//////////////////
// WEBPACK FOOTER
// ./src/shared/Authentication/tracking.ts
// module id = 240
// module chunks = 2